<input type="file" name="{{uploadAttachmentId}}" id="{{uploadAttachmentId}}" style="visibility:hidden; width:0px;" />
<p-button styleClass="btn disc-btn-upload btn-lg" type="button" label="{{'FileUpload.ChooseFile' | transloco}}" (onClick)="uploadClicked()"></p-button>
<div *ngFor="let uploadedFile of UploadedOutputFiles">
    <span class="pi pi-paperclip"></span><span class="filename">{{uploadedFile.name}}</span>
</div>